export default "__VITE_ASSET__4Oy$TqO4__"